import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ButtonSvgIcon from '@components/shared/buttons/svg-icon/ButtonSvgIcon';
import PopOver from '../PopOver.js';
import styles from './PopOverButton.module.scss';
import Menu from './menu.svg';

PopOverButton.propTypes = {
  buttonClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  controlled: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

PopOverButton.defaultProps = {
  buttonClassName: '',
  className: '',
};

export default function PopOverButton(props) {
  const {
    buttonClassName,
    children,
    className,
    controlled = false,
    open,
    setOpen,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  return (
    <span className={ `${styles.Container} ${className}` }>
      <ButtonSvgIcon
        classNames={ buttonClassName }
        onClick={ () => {
          if (controlled) {
            setOpen(!open);
          } else {
            setIsOpen(!isOpen);
          }
        } }
      >
        <Menu />
      </ButtonSvgIcon>
      <PopOver
        className={ styles.PopOverPosition }
        isOpen={ controlled ? open : isOpen }
        setIsOpen={ controlled ? setOpen : setIsOpen }
      >
        {children}
      </PopOver>
    </span>
  );
}
